import React, { type ReactElement } from "react";
import { useFeatureEnabled } from "@/lib/use-features";
import { RD_SCHEDULE_FLAG } from "../../../../shared/features";
import {
  UngatedAppointmentActionDialogs,
  RdScheduleFlagGate,
  type AppointmentActionDialogsProps,
} from "./appointment-action-dialogs";

// NO-876. The dialogs as the Week view mounts them: they exist only while the
// `rd-schedule` flag reads on, so a flag that is off or missing renders nothing.

export function ConnectedAppointmentActionDialogs(
  props: AppointmentActionDialogsProps
): ReactElement | null {
  const enabled = useFeatureEnabled(RD_SCHEDULE_FLAG);

  return (
    <RdScheduleFlagGate enabled={enabled}>
      <UngatedAppointmentActionDialogs {...props} />
    </RdScheduleFlagGate>
  );
}
